module.exports = __webpack_public_path__ + "static/media/18.19c0ac63.png";